import { render, staticRenderFns } from "./StatusBadge.vue?vue&type=template&id=8e6e4386&scoped=true"
import script from "./StatusBadge.vue?vue&type=script&lang=js"
export * from "./StatusBadge.vue?vue&type=script&lang=js"
import style0 from "./StatusBadge.vue?vue&type=style&index=0&id=8e6e4386&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6e4386",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e6e4386')) {
      api.createRecord('8e6e4386', component.options)
    } else {
      api.reload('8e6e4386', component.options)
    }
    module.hot.accept("./StatusBadge.vue?vue&type=template&id=8e6e4386&scoped=true", function () {
      api.rerender('8e6e4386', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/management/contract/components/StatusBadge.vue"
export default component.exports